import { gql } from '@apollo/client';

import { FileUploadFragment } from './FileUpload.graphql';
import { ProductFragment } from './Product.graphql';
import { ProjectRdDeterminationFragment } from './ProjectRdDetermination.graphql';

export const RdProjectFragment = gql`
  fragment RdProject on RdProject {
    id
    name
    description
    purpose
    businessComponent
    businessPurpose
    consideredForRd
    isSection174Eligible
    disallowances
    improvedAspects
    technicalChallenges
    processOfExperimentation
    selectedCategory
    rdDocumentationStatus
    projectOwnerId
    projectOwner {
      id
      fullName
    }
    rdDetermination {
      ...ProjectRdDetermination
    }
    workstreamNames
    workstreamNamesSearch
    ticketCount
    supportingDocuments {
      ...FileUpload
    }
    processingState
    product {
      ...Product
    }
    clusterType
    approvalTime
    approvalComment
    aiGuidance
    isTechnicallyUncertain
    isCustomerFacingDevelopment
    isInnovativeAndRisky
  }
  ${ProjectRdDeterminationFragment}
  ${FileUploadFragment}
  ${ProductFragment}
`;
